import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgViewCombo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M5.61 42.375V5.625h9.187v36.75zm13.781 0V5.625h9.187v36.75zm13.782 0V5.625h9.187v36.75z" }) }) })
});
export default SvgViewCombo;
